<ng-container>
    <iframe
    #mapIframe
    [src]="safeUrl"
    id="1200.aero"
    title="Live map 1200.aero"
    class="map-container"
    loading="lazy"
    allowfullscreen
    ></iframe>
</ng-container>